import { useCallback, useState } from "react";
import { apiClient } from "@finitless/shared/lib";

const SNAPSHOT_FIELDS = "id,categories,available_products_count";

/**
 * Category and product counts of one business.
 * Evidence for an import result; never throws. `null` when the read fails.
 * @returns {Promise<{ categories: number, products: number } | null>}
 */
export const fetchBusinessMenuSnapshot = async (businessId) => {
  if (businessId == null || businessId === "") return null;
  try {
    const response = await apiClient.get(`/business/${businessId}`, {
      params: {
        params: SNAPSHOT_FIELDS,
        mode: "dashboard",
      },
    });
    const result = response?.result;
    if (response?.error || !result) return null;
    const { categories, available_products_count: products } = result;
    return {
      categories: Array.isArray(categories) ? categories.length : 0,
      products: Number(products) || 0,
    };
  } catch {
    return null;
  }
};

/** On-demand snapshot for a Check now action. Nothing is fetched until `refetch`. */
export const useBusinessMenuSnapshot = (businessId) => {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const refetch = useCallback(async () => {
    setLoading(true);
    const next = await fetchBusinessMenuSnapshot(businessId);
    setSnapshot(next);
    setFailed(next === null);
    setLoading(false);
    return next;
  }, [businessId]);

  return { snapshot, loading, failed, refetch };
};
